import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { SUBSCRIPTIONS_LIST_QUERY_KEY } from "./constants";
import { buildSubscriptionsQuery, type SubscriptionsListFilters } from "./subscription-filters";
import type { AdminSubscriptionListResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/subscriptions`
 * is a light DB-only projection (no Stripe call); the rich shape is the
 * separate detail endpoint.
 */
async function fetchSubscriptions(
  filters: SubscriptionsListFilters,
): Promise<AdminSubscriptionListResponse> {
  return httpClient<AdminSubscriptionListResponse>(
    `/api/admin/subscriptions${buildSubscriptionsQuery(filters)}`,
  );
}

export function useSubscriptionsList(filters: SubscriptionsListFilters) {
  return useQuery({
    queryKey: [
      ...SUBSCRIPTIONS_LIST_QUERY_KEY,
      filters.query.trim(),
      filters.status ?? "all",
      filters.tier ?? "all",
      filters.page,
    ] as const,
    queryFn: () => fetchSubscriptions(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
